/*globals define,require*/

/**
 * BBC iStats adapter to log Music Favourite plugin events.
 * @module plugins/musicfavourite/stats
 */
define(
    'plugins/musicfavourite/stats',['jquery-1.9', 'exports'],
    function($, Stats) {

        'use strict';

        Stats = Stats || {};

        var ACTION_NAME = 'favourites-button',

            /**
             * Creates a Stats logging listener.
             * @param  {string} actionType       What happened.
             * @return {Function} listener.
             */
            createListener = function(actionType) {
                return function(button) {
                    Stats.log(actionType, ACTION_NAME, Stats.getLabels(button));
                };
            },

            /**
             * Map of published button events to Stats logging listener for a given actionType.
             * @type {Object}
             */
            EVENT_LISTENERS = {
                'toggled.toggledAdd': createListener('add'),
                'toggled.toggledRemove': createListener('remove'),
                'managementMode.removeYes': createListener('remove-yes'),
                'managementMode.removeNo': createListener('remove-no'),
                'feedbackMode.more': createListener('more'),
                'feedbackMode.dismiss': createListener('dismiss'),
                'feedbackMode.undo': createListener('undo')
            };

        Stats._listeners = EVENT_LISTENERS;


        /**
         * BBC iStats adapter. Log a hidden event.
         * @param  {string}   actionType action_type label.
         * @param  {string}   actionName action_name label.
         * @param  {object}   labels     JSON of extra labels.
         * @param  {Function} callback   Function to call once complete.
         */
        Stats.log = function(actionType, actionName, labels, callback) {
            require(['istats-1'], function(istats) {
                labels['breakpoint_type'] = getBreakpointType();

                (typeof(istats.log) === 'function') && istats.log(
                    actionType,
                    actionName,
                    labels,
                    callback
                );
            });

        };


        /**
         * Log an event directly. Primarily used by tests.
         * @param  {string} eventName Name of published event topic.
         * @param  {button} button    Favourite button that published event.
         */
        Stats.logEvent = function(eventName, button) {
            if (EVENT_LISTENERS[eventName]) {
                EVENT_LISTENERS[eventName](button);
            }
        };


        /**
         * Record events that occur on a given PubSub object.
         */
        Stats.logEvents = function(PubSub) {
            if (PubSub && typeof(PubSub.subscribe) == 'function') {
                $.each(EVENT_LISTENERS, function(eventName, listener) {
                    PubSub.subscribe(eventName, listener);
                });
            }
        };


        /**
         * Retrieve stats labels to record.
         */
        Stats.getLabels = function(button) {

            var labels = (button.item.label) ? JSON.parse(button.item.label) : {};
            labels['breakpoint_type'] = getBreakpointType();
            labels['favourites_type'] = button.item.type;

            switch (button.item.type) {
                case "artist":
                    labels['artist_id'] = button.item.id;
                    break;
                case "track":
                case "track_segment":
                case "track_event":
                    // The button id can contain extra data to be used by other services, split by '#',
                    // when the item type is 'track' variant. Istats requires only the record id, which is the first
                    // section of the id string.
                    labels['record_id'] = button.item.id.split('#', 1)[0];
                    break;
                case "programme":
                    labels['programme_id'] = button.item.id;
                    break;
                case "playlist":
                    labels['playlist_id'] = button.item.id;
                    break;
                case "tlec":
                    labels['tlec_id'] = button.item.id;
                    break;
            }

            return labels;
        };

        function getBreakpointType() {
            var width = $(window).width();

            if (width >= 1008) {
                return '1008px-up';
            } else if (width >= 600) {
                return '600px-1007px';
            } else if (width >= 400) {
                return '400px-599px';
            } else {
                return '0-399px';
            }
        }

        return Stats;
    }
);

